export const GET_MENUS = "GET_MENUS";
